/**
 * Словарь человеческих текстов причин отказа СМЕНЫ ТАРИФА — FOLLOWER закрытого списка сервера
 * (#1761 промокод, #2281 собственный выбор; словарь общий, потому что переход общий).
 *
 * Дом истины — сервер; словарь обязан покрывать известный список 1:1 (зуб полноты
 * в `tariffDenyText.test.ts`) и НЕ имеет права молчать о неизвестном: рассинхрон с
 * сервером показывается fallback-веткой «неизвестная причина: <код>», а не глотается
 * (поправка формы из прогона Веснина 12.08 — «рассинхрон показывается, не молчит»).
 *
 * Все отказы визуально одинаковы (alert-error) — различие в ТЕКСТЕ, не в цвете
 * (разбор Родченко 12.08).
 */
import { TARIFF_DENY_REASONS, type TariffDenyReason } from '@/api/tariff';

const DENY_TEXT: Record<TariffDenyReason, string> = {
  // ОБЩАЯ причина: приезжает и с промокода, и с собственного выбора. Формулировка не смеет
  // называть код — на второй дороге его не было, и «сообщите нам об этом коде» отправило бы
  // человека искать то, чего он не вводил.
  unknown_target_tariff: 'Такого тарифа больше нет — обновите страницу; если он был показан в списке, сообщите нам',
  /** Общая причина — формулировка нейтральна к дороге (см. выше). */
  same_tariff: 'Этот тариф у вас уже подключён',
  promo_downgrade_forbidden: 'Код ведёт на тариф ниже текущего — по коду тариф не понижается',
  promo_already_redeemed: 'Этот код уже был использован',
  promo_revoked: 'Код отозван выпустившей стороной',
  promo_expired: 'Срок действия кода истёк',
  promo_target_mismatch: 'Код не подходит к вашему тарифу',
  promo_not_single_use: 'Код выпущен с ошибкой — сообщите нам об этом коде',
  promo_unknown: 'Такого кода не существует — проверьте написание',
  membrane_unknown: 'Ваша мембрана не найдена — перезайдите в кабинет',
  grid_unavailable: 'Сетка тарифов сейчас недоступна — попробуйте позже',
  tariff_moved_concurrently: 'Ваш тариф только что изменился с другого устройства — обновите страницу и повторите',
  self_gate_closed: 'Смена тарифа своим выбором сейчас закрыта',
  preview_required: 'Тариф не изменён: при понижении часть записей уйдёт в архив — посмотрите и подтвердите',
  freeze_failed: 'Тариф не изменён: сервер записей не ответил',
  media_unavailable: 'Тариф не изменён: сервер записей недоступен — попробуйте позже',
};

/** Человеческий текст причины; неизвестная причина не молчит, а называется кодом. */
export function tariffDenyText(reason: string): string {
  if ((TARIFF_DENY_REASONS as readonly string[]).includes(reason)) {
    return DENY_TEXT[reason as TariffDenyReason];
  }
  return `Неизвестная причина отказа: ${reason}`;
}
